<template>
  <div class="car" ref="animation"></div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import lottie from 'lottie-web'
import lottiePraise from '../assets/loading_plane.json'

const animation = ref(null)

onMounted(() => {
  if (animation.value) {
    lottie.loadAnimation({
      container: animation.value,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: lottiePraise
    })
  }
})
</script>

<style scoped lang="less">
.car {
  width: 100px;
  height: 70px;
}
</style>
